import { fadeOut } from './helpers';
export const fadeOutPreloader = () => {
    const preloader = document.querySelector('.site-preloader');
    if (preloader)
        fadeOut(preloader);
};
export const initScrollHeader = () => {
    const header = document.querySelector('.js--site-header');
    if (!header)
        return;
    const update = () => {
        header.classList.toggle('scroll-header', Math.floor(window.scrollY) > 100);
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
};
export const initScrollTop = () => {
    const button = document.querySelector('.js--scroll-top');
    if (!button)
        return;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    button.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
    });
};
